import { Box, Tabs, Tab, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import apiReq from 'core/api';
import Loader from 'components/Loader';
import { USE_NEW_SHELL } from 'core/flags';
import { PageShell } from 'components/AppShell';
import TextTab from '../components/TextTab';
import FilesTab from '../components/FilesTab';
import styles from './GeneralInformation.module.scss';

export const GeneralInformationPage = () => {
  const currProject = useSelector((state) => state.reducer.project.id);
  const [activeTab, setActiveTab] = useState(0);

  const { isLoading } = useQuery({
    queryKey: ['getBusiness', currProject],
    queryFn: () => apiReq(`projects/artifacts?project_id=${currProject}`),
  });

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const tabs = (
    <Tabs value={activeTab} onChange={handleTabChange} indicatorColor="primary" textColor="primary">
      <Tab label="Текст" />
      <Tab label="Файлы" />
    </Tabs>
  );

  const content = (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {activeTab === 0 && <TextTab />}
      {activeTab === 1 && <FilesTab />}
    </Box>
  );

  if (USE_NEW_SHELL) {
    return (
      <PageShell
        title="Общая информация"
        subtitle="Текст и файлы проекта, доступные модели"
        toolbar={tabs}
      >
        {isLoading ? <Loader /> : content}
      </PageShell>
    );
  }

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Box className={styles.pageContainer}>
          <Typography variant="h4" className={styles.pageTitle} gutterBottom>
            Общая информация
          </Typography>
          <Box className={styles.tabsContainer}>{tabs}</Box>
          <Box className={styles.tabContent}>{content}</Box>
        </Box>
      )}
    </>
  );
};
